var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCosmote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 36,
    viewBox: "0 0 122 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15614_292665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2161 12.1558H61.4235C60.5073 12.1558 60.418 12.6053 60.418 12.965V14.6508H63.5015V23.6193H66.1381V14.6508H69.244V12.965C69.244 12.6053 69.1546 12.1558 68.2161 12.1558Z",
    fill: "#3B61A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8707 20.2477C9.42931 20.8097 10.2337 21.6189 10.3454 21.7537C9.56337 22.6079 8.0663 23.8441 5.96593 23.8441C2.7707 23.8441 0 21.3491 0 17.8876C0 14.4485 2.72601 11.9086 5.96593 11.9086C8.11099 11.9086 9.51868 13.0549 10.3231 13.8641C10.2337 13.954 9.4293 14.7632 8.89304 15.3476C8.44615 15.8197 7.90989 15.4825 7.64176 15.3027C7.23956 15.0329 6.72564 14.7632 5.96593 14.7632C4.31245 14.7632 2.92711 16.1568 2.92711 17.8876C2.92711 19.6408 4.26777 20.9895 5.96593 20.9895C6.59158 20.9895 7.17253 20.7872 7.64176 20.4276C7.97692 20.1803 8.49084 19.8207 8.8707 20.2477Z",
    fill: "#509E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7266 17.8876C10.7266 14.5834 13.3632 11.9086 16.6478 11.9086C19.9324 11.9086 22.5914 14.5834 22.5914 17.8876C22.5914 21.1918 19.9324 23.8441 16.6702 23.8441C13.3855 23.8441 10.7266 21.1918 10.7266 17.8876ZM13.609 17.8876C13.609 19.6408 14.9273 21.012 16.6702 21.012C18.3907 21.012 19.6866 19.6408 19.6866 17.8876C19.6866 16.1343 18.3683 14.7407 16.6478 14.7407C14.905 14.7407 13.609 16.1343 13.609 17.8876Z",
    fill: "#509E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2852 17.8876C48.2852 14.5834 50.9441 11.9086 54.2064 11.9086C57.4687 11.9086 60.15 14.5834 60.15 17.8876C60.15 21.1918 57.491 23.8441 54.2287 23.8441C50.9441 23.8441 48.2852 21.1918 48.2852 17.8876ZM51.1676 17.8876C51.1676 19.6408 52.4859 21.012 54.2287 21.012C55.9493 21.012 57.2676 19.6408 57.2676 17.8876C57.2676 16.1343 55.9269 14.7407 54.2064 14.7407C52.4635 14.7407 51.1676 16.1343 51.1676 17.8876Z",
    fill: "url(#paint0_linear_15614_292665)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3048 12.1558H45.5169L47.2821 23.6193H44.3326L43.4612 17.0334L40.2436 23.6193L37.0931 16.9884L36.311 23.6193H33.4062L34.881 13.7741C34.9927 13.0324 35.1044 12.1558 36.0876 12.1558H37.9421L40.2883 17.6628L42.0982 13.3246C42.2769 12.8526 42.4557 12.1558 43.3048 12.1558Z",
    fill: "#509E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1977 21.2592C32.9574 18.7867 30.9018 17.483 29.8963 16.921C28.8908 16.3366 27.8853 15.9095 27.6171 15.7972C27.3714 15.6848 26.7234 15.415 26.9915 14.8306C27.416 13.8641 29.2036 14.8531 30.0303 15.2577C30.8571 15.6623 31.0358 15.2352 31.1029 15.1004L32.019 13.3696C32.019 13.3696 29.8739 12.0209 27.9746 11.9086C25.1146 11.7287 23.7069 13.7742 23.7739 15.2577C23.7739 16.9885 25.5168 17.955 27.2373 18.7642C28.9578 19.5509 29.2036 20.0005 29.2036 20.3601C29.2036 20.6973 29.0025 21.3266 27.93 21.3266C26.8574 21.3266 25.8073 20.3601 25.4497 20.0904C25.0922 19.7982 24.7794 19.933 24.5336 20.2477C24.2878 20.5624 23.3047 21.7762 23.3047 21.7762C24.1985 22.5854 25.7402 23.8666 28.2875 23.8666C30.2985 23.8666 31.6615 22.9225 32.1977 21.2592Z",
    fill: "#509E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5245 23.844C77.6472 23.8216 78.8985 22.8775 79.5465 22.2032C79.6359 22.1133 79.1443 20.877 78.5857 20.2926C78.1388 19.8206 77.6026 20.1577 77.3568 20.3151C76.8875 20.6073 76.463 20.9669 75.4798 20.9894C74.2956 21.0119 73.2678 20.2252 72.7762 19.2137H76.0831V16.5388H72.7762C73.2678 15.5049 74.3179 14.7631 75.5022 14.7631C76.2395 14.7631 76.7982 15.0328 77.2004 15.3026C77.4461 15.4599 78.0048 15.7971 78.4293 15.3251C78.9879 14.7406 79.4795 13.4819 79.3901 13.392C78.5857 12.6952 77.6026 11.9534 75.5245 11.9085C72.2846 11.8186 69.5586 14.4709 69.5586 17.8875C69.5586 21.3041 72.3293 23.844 75.5245 23.844Z",
    fill: "#3B61A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3754 13.9541C89.3754 13.9541 88.9956 2.40063 76.8626 0.0180097C64.7296 -2.36461 90.9395 -4.70227 90.9395 -4.70227H101.821V15.7523H89.3754V13.9541Z",
    fill: "#E20074"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.474 0.0180664C115.496 0.0180664 121.998 6.55903 121.998 14.6285V35.9821H89.375V0.0180664H107.474Z",
    fill: "#E20074"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.256 27.598V26.2269H101.173C102.781 26.2269 103.519 25.2828 103.519 23.8667V9.61599H103.251C100.234 9.61599 98.3349 11.6165 98.3349 14.561V14.8308H97.1953V8.26733H113.306V14.8308H112.166V14.561C112.166 11.6165 110.267 9.61599 107.25 9.61599H106.982V23.8667C106.982 25.2828 107.719 26.2269 109.328 26.2269H110.244V27.598H100.256ZM113.306 17.146V21.0121H109.485V17.146H113.306ZM101.016 17.146V21.0121H97.1953V17.146H101.016Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15614_292665",
    x1: 49.3543,
    y1: 21.3044,
    x2: 59.1093,
    y2: 14.5149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#509E2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#509E2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4A8D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#3C659D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#3B61A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B61A6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15614_292665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmote);
export default __webpack_public_path__ + "static/media/Cosmote.fb82a04a5f64db5aac3229d2302eabb5.svg";
export { ForwardRef as ReactComponent };